import { useSessionStorageBase } from './useSessionStorageBase';
/**
 * Hook that allows to use *sessionStorage* without reference to any **application**.
 *
 * @template T - The type of the state to be stored in session storage.
 * @template K - The type of the key.
 * @param key - The key under which the value will be stored in session storage.
 * @param initialValue - The initial value of the state or a function that returns the initial value.
 * @param [options] - Options for customizing the behavior of serialization and deserialization (optional).
 * @returns A tuple containing the stored value, a function to set the value and a function to remove the key from storage.
 * @example
 * ```tsx
 * // Access the `count` value, the `setCount` function to update it and `removeCount` function to remove the key from storage.
 * const [count, setCount, removeCount] = useCoreSessionStorage('count', 0);
 * // Acts like a native useState from react.
 * setCount(prevValue => prevValue + 1)
 * ```
 */
// TODO: to delete this Legacy hook later. When V2 version is used everywhere
// export const useCoreSessionStorage = <T, K extends string>(key: K, initialValue: T | (() => T), options?: UseSessionStorageOptions<T>) =>
// 	useSessionStorageBase(key, initialValue, options);
/**
 * Hook that allows to use *sessionStorage* without reference to any **application**.
 *
 * @template T - The type of the state to be stored in session storage.
 * @template K - The type of the key.
 * @param key - The key under which the value will be stored in session storage.
 * @param initialValue - The initial value of the state or a function that returns the initial value.
 * @param [options] - Options for customizing the behavior of serialization and deserialization (optional).
 * @returns A tuple containing the stored value, a function to set the value and a function to remove the key from storage.
 * @example
 * ```tsx
 * // Access the `count` value, the `setCount` function to update it and `removeCount` function to remove the key from storage.
 * const [count, setCount, removeCount] = useCoreSessionStorage('count', 0);
 * // Acts like a native useState from react.
 * setCount(prevValue => prevValue + 1)
 * ```
 */
export const useCoreSessionStorage = (key, initialValue, options) => useSessionStorageBase(key, initialValue, {
    serializer: options?.serializer,
    deserializer: options?.deserializer?.(initialValue),
    initializeWithValue: options?.initializeWithValue,
});
